import { useMemo } from 'react';

export interface TableInheritedProps {
  cell?: unknown;
  column?: unknown;
  // getValue returns the cell's value for the current column, whose type
  // varies per column; it is dynamic by nature.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getValue?: () => any;
  model?: unknown;
  path?: unknown;
  renderValue?: unknown;
  row?: unknown;
  table?: unknown;
  [key: string]: unknown;
}

export const useTableInheritedProps = (props: TableInheritedProps) => {
  const {
    cell,
    column,
    getValue,
    model,
    path,
    renderValue,
    row,
    table,
    ...inheritedProps
  } = props;

  const propReturns = useMemo(() => {
    const extractedProps = {
      cell,
      column,
      getValue,
      model,
      path,
      renderValue,
      row,
      table
    };

    return {
      ...extractedProps,
      extractedProps,
      inheritedProps
    };
  }, [
    cell,
    column,
    getValue,
    model,
    path,
    renderValue,
    row,
    table,
    inheritedProps
  ]);

  return propReturns;
};
